<template>
  <div v-if="info && info.resume && info.resume.file" class="jin-m-resume">
    <p
      class="name"
      @click="$router.push({
        path: '/list/resume/Resume',
        query: {
          type: $route.query.type
        }
      })"
    >
      <span>上传成功</span>
      <Icon name="arrow-right" />
    </p>
    <div class="jin-m-resume-item">
      <img src="@/assets/resume/resume.png" alt="">
      <span>{{ info.resume.file.name }} ({{ handleSize(info.resume) }})</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    info: {
      type: Object,
      default: () => {}
    }
  },
  created() {
  },
  methods: {
    handleSize(item) {
      const m = (item.file.size / 1024 / 1024)
      const kb = (item.file.size / 1024)
      const curr = m > 1 ? m.toFixed(1) + ' M' : kb.toFixed(2) + ' K'
      return curr
    }
  }
}
</script>

<style lang="scss" scoped>
.jin-m {
  &-resume {
    .name {
      margin-top: 20px;
      margin-bottom: 18px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      span {
        font-size: 15px;
        color: #3d4351;
        line-height: 18px;
      }

      i {
        font-size: 14px;
        color: #787b8a;
      }
    }

    &-item {
      padding: 15px 14px;
      margin-bottom: 14px;
      background: #f3f9fe;
      display: flex;
      align-items: center;

      img {
        width: 24px;
        margin-right: 10px;
      }

      span {
        font-size: 14px;
        color: #3d4351;
        line-height: 20px;
      }

      &:nth-last-child(1) {
        margin-bottom: 0;
      }
    }
  }
}
</style>
